<odl-dialog
  class="payment-blocked-dialog"
  [open]="isBlocked()"
  (odl-before-close)="preventClose($event)"
>
  <div slot="header" class="header">
    <span>{{ 'PPU_BLOCKED_DIALOG.TITLE' | translate }}</span>
  </div>
  <p class="message">
    {{ descriptionKey() | translate }}
  </p>
  @if (hasExit) {
    <div slot="footer" class="footer">
      <odl-button (click)="goToPlatform()">{{ 'GO_BACK' | translate }}</odl-button>
    </div>
  }
</odl-dialog>
